import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
interface CustomFieldFlowStylesProps {
  isNextStage?: boolean
}

const useStyles = makeStyles<Theme, CustomFieldFlowStylesProps>(theme => ({
  title: {
    flexBasis: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingTop: '1.5rem',
    color: '#323436',
    // add border on top only on next stages since each custom field group has border at bottom.
    borderTop: ({ isNextStage }) =>
      isNextStage ? '1px solid rgba(230, 234, 236, 0.9)' : 'none',
    fontSize: theme.size.sm,
    '& > :nth-child(1)': {
      textTransform: 'capitalize'
    },

    '& > :nth-child(2)': {
      opacity: '0.35',
      color: '#323436',
      fontSize: theme.size.sm,
      fontStyle: 'italic'
    },

    [theme.breakpoints.down('lg')]: {
      paddingTop: '0',
      paddingBottom: '0.5rem'
    }
  },

  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },

  gridItem: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '35px',
    margin: '0.25rem 0'
  }
}))

export default useStyles
